import { TimeSelectInput } from '../inputs';
import createField from './createField';

const TimeSelectField = createField(TimeSelectInput);

export default TimeSelectField;
